import fetch from '../config/api'

/**
 * 意见反馈
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {user_name} 姓名
 * param {user_mail} 邮箱
 * param {content} 反馈内容
 * param {phone} 手机号
 * param {captcha} 验证码
 */
const Feedback = (language = '1', user_name, user_mail, content, phone, captcha) => fetch('/feedback/feedback_save', {
    p: 'wx',
    language,
    user_name,
    user_mail,
    content,
    phone,
    captcha,
}, 'POST');

export default {
    Feedback
}